module.exports = __webpack_public_path__ + "media/images/home/logo-peacock-white-409e0f136a4c1b4abdb063168f65e791.svg";